<div>
    <Modal :title="L('CreateNewRole')" :value="value" @on-ok="save" @on-visible-change="visibleChange">
        <Form ref="roleForm" label-position="top" :rules="roleRule" :model="editRole">
            <Tabs value="detail">
                <TabPane :label="L('RoleDetails')" name="detail">
                    <FormItem :label="L('RoleName')" prop="name">
                        <Input v-model="editRole.name" :maxlength="32" :minlength="2"></Input>
                    </FormItem>
                    <FormItem :label="L('DisplayName')" prop="displayName">
                        <Input v-model="editRole.displayName" :maxlength="32" :minlength="2"></Input>
                    </FormItem>
                    <FormItem :label="L('Description')" prop="description">
                        <Input type="textarea" :rows="3" v-model="editRole.description" :maxlength="1024"></Input>
                    </FormItem>
                </TabPane>
                <TabPane :label="L('RolePermission')" name="permission">
                    <!-- <CheckboxGroup v-model="role.permissions">
                            <Checkbox :label="permission.name"
                                      v-for="permission in permissions"
                                      :key="permission.name"><span>{{permission.displayName}}</span></Checkbox>
                        </CheckboxGroup> -->
                    <Tree :data="permissions" ref="permissionTree" show-checkbox></Tree>
                </TabPane>
            </Tabs>
        </Form>
        <div slot="footer">
            <Button @click="cancel">{{L('Cancel')}}</Button>
            <Button @click="save" type="primary">{{L('OK')}}</Button>
        </div>
    </Modal>
</div>
